import React, { useState } from 'react';
import { IoSettingsSharp } from 'react-icons/io5';
import './SettingsButton.css';

const SettingsButton = ({ onClick }) => {
  const [rippleActive, setRippleActive] = useState(false);

  const handleClick = () => {
    setRippleActive(true);
    setTimeout(() => setRippleActive(false), 600);
    onClick();
  };

  return (
    <div className="settings-button-container">
      <button
        className={`settings-button${rippleActive ? ' ripple-active' : ''}`}
        onClick={handleClick}
      >
        <span className="settings-button-ripple" />
        <span className="settings-button-icon">
          <IoSettingsSharp size={30} />
        </span>
      </button>
    </div>
  );
};

export { SettingsButton };
